const KEY = "stakes_active_league_id";
const DEVICE_USER_KEY = "stakes_device_user_id";
const AUTH_TOKEN_KEY = "stakes_auth_token";

export function getActiveLeagueId() {
  try { return localStorage.getItem(KEY) || null; } catch { return null; }
}

export function setActiveLeagueId(id) {
  try {
    if (id) localStorage.setItem(KEY, id);
    else localStorage.removeItem(KEY);
  } catch { /* ignore */ }
}

export function clearActiveLeague() { setActiveLeagueId(null); }

export function getDeviceUserId() {
  try { return localStorage.getItem(DEVICE_USER_KEY) || null; } catch { return null; }
}

export function setDeviceUserId(id) {
  try {
    if (id) localStorage.setItem(DEVICE_USER_KEY, id);
    else localStorage.removeItem(DEVICE_USER_KEY);
  } catch { /* ignore */ }
}

export function clearDeviceUserId() {
  setDeviceUserId(null);
  // Phase 19 — also wipe the bearer token; the device-binding logout always
  // implies the session ends too.
  try { localStorage.removeItem(AUTH_TOKEN_KEY); } catch { /* ignore */ }
}
